import { Stack } from '@fluentui/react';
import React, { useEffect } from 'react';

// assets

import { useStore } from '../../stores/root';
import OrdersList from '../../components/orders/general/list';
import { faHome } from '@fortawesome/pro-light-svg-icons';

interface IOrdersListPageProps {
}

const OrdersListPage: React.FC<IOrdersListPageProps> = (props: IOrdersListPageProps) => {
    const {topbar} = useStore();

    useEffect(() => {
        topbar.show("Orders", [
            {key: "home", icon: faHome, href: "/"},
            {key: "orders", text: 'Orders', href: "/orders"},
            {key: "list", text: 'List'}
        ])
    }, []);

    return <Stack>
        <OrdersList />
    </Stack>;
};

export default OrdersListPage;
